import { useCallback } from 'react';

/**
 * Accepts a function and list of dependencies for memoizing
 *
 * This type is used when the component will enforce memoization of the function internally rather than leaving it up to the calling code.
 * Most likely when memoization is necessary for rendering performance.
 */

/**
 * Memoizes the provided MemoizableFunction using React's useCallback
 */
export function useMemoizableFunction({
  fn,
  deps
}) {
  return useCallback(fn, deps);
}